import React from "react";

export const AnimatedBackground = ({ variant = "hero", intensity = "full" }) => {
  const opacity = intensity === "soft" ? "opacity-50" : "opacity-100";
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${opacity}`}
      data-testid={`animated-bg-${variant}`}
    >
      <div className="orb orb-deep -top-40 -left-40" />
      <div className="orb orb-cyan top-1/3 -right-32" />
      <div className="orb orb-bright bottom-0 left-1/4" />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 0%, rgba(3,172,239,0.10), rgba(20,16,52,0) 60%)",
        }}
      />
      <div
        className="absolute inset-x-0 bottom-0 h-32"
        style={{
          background:
            "linear-gradient(180deg, rgba(20,16,52,0) 0%, #141034 100%)",
        }}
      />
    </div>
  );
};
